export default "__VITE_ASSET__111b9c99__"